import { ErrorHandler, Injectable, inject } from '@angular/core';
import { ErrorReportingService } from './error-reporting.service';

/**
 * Forwards Angular zone errors to the telemetry sink, then preserves the
 * default behaviour (log to console) so local dev is unchanged.
 */
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private reporter = inject(ErrorReportingService);

  handleError(error: unknown): void {
    try {
      this.reporter.report(error, 'angular');
    } catch {
      /* never let the error handler throw */
    }
    console.error(error);
  }
}
